import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useStoreActions, useStoreState } from 'easy-peasy';

import Chart from './Chart';
import ChartOverlayText from './ChartOverlayText';
import ViewZoomer from '~/components/ViewZoomer';
import { resizeIframeDebounced } from '~/utils';

const Wrapper = styled.div`
  position: relative;
  font-size: 0.9em;
  margin-top: 20px;
`;

const useWidth = (ref) => {
  const [width, setWidth] = useState(null);

  useEffect(() => {
    if (ref.current) {
      const bounds = ref.current.getBoundingClientRect();
      setWidth(bounds.width);

      window.addEventListener('resize', () => {
        const b = ref.current.getBoundingClientRect();
        setWidth(b.width);
      });
    }
  }, []);

  return width;
};

const Visualisation = () => {
  const ref = useRef();
  const width = useWidth(ref);
  const loadData = useStoreActions((state) => state.app.loadData);
  const data = useStoreState((state) => state.app.data);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    resizeIframeDebounced();
  }, [width]);

  return (
    <>
      <Wrapper ref={ref}>
        {data && data.length && width > 0 && (
          <>
            <Chart outerWidth={width} data={data} />
            <ChartOverlayText data={data} />
          </>
        )}
      </Wrapper>
      <ViewZoomer />
    </>
  );
};

export default Visualisation;
